import type { VoidFunctionComponent } from 'react';

import Description from '../../../../shared/vulns/Drawer/Description';
import type { SelectedVuln } from '../../../../../../shared/organizationPackages/response';

import { getSelectedVulnDescription } from './utils';

type Props = { isLoading: boolean; selectedVuln?: SelectedVuln };

/**
 * Container component for the VulnerabilityDrawerDescription
 */
const PackageVersionVulnerabilityDrawerDescription: VoidFunctionComponent<Props> = ({ isLoading, selectedVuln }) => {
  const description = getSelectedVulnDescription(selectedVuln);
  return (
    <Description
      isLoading={isLoading}
      description={description}
    />
  );
};

export default PackageVersionVulnerabilityDrawerDescription;
